import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CLAIMSSEARCH_FEATURE_KEY,
  ClaimsSearchState,
} from './claims-search.reducer';
// Lookup the 'ClaimsSearch' feature state managed by NgRx
const getClaimsSearchState = createFeatureSelector<ClaimsSearchState>(
  CLAIMSSEARCH_FEATURE_KEY,
);

const getSearchStage = createSelector(
  getClaimsSearchState,
  (state) => state.searchStage,
);

const getProviderLoadingState = createSelector(
  getClaimsSearchState,
  (state) => state.providerLoadingState,
);
const getProviderLoadingError = createSelector(
  getClaimsSearchState,
  (state) => state.providerLoadingError,
);

const getError = createSelector(getClaimsSearchState, (state) => state.error);

const getMemberSearchCriteria = createSelector(
  getClaimsSearchState,
  (state) => state.searchCriteria,
);

const getClaimsSearchCriteria = createSelector(
  getClaimsSearchState,
  (state) => state.searchClaimCriteria,
);

const getTabSelection = createSelector(
  getClaimsSearchState,
  (state) => state.selectedTab,
);

const getClaimsSearchResults = createSelector(
  getClaimsSearchState,
  (state) => state.results,
);

const getClaimDetails = createSelector(
  getClaimsSearchState,
  (state) => state.claimDetails,
);

const getClaimDetailsClaimInfo = createSelector(
  getClaimDetails,
  (details) => details?.claimInfoObject,
);

const getClaimDetailsMemberInfo = createSelector(
  getClaimDetails,
  (details) => details?.memberObject,
);

const getClaimRefNum = createSelector(
  getClaimDetailsClaimInfo,
  (claimInfo) => claimInfo?.claimReferenceNumber || '',
);

const getClaimsDDAR = createSelector(
  getClaimsSearchState,
  (state) => state.remittanceDetailsResponse,
);

const getMemberLists = createSelector(
  getClaimsSearchState,
  (state) => state.memberLists,
);

const getIsMultiplePatients = createSelector(
  getClaimsSearchState,
  (state) => state.isMultiplePatients,
);

const getUniqueIdentifier = createSelector(
  getClaimsSearchState,
  (state) => state.multiplePatientUniqueIdentifier,
);

const getServiceLineInfo = createSelector(
  getClaimDetailsClaimInfo,
  (claimInfo) => claimInfo?.serviceLineInfoArray || [],
);

const getAdjustments = createSelector(
  getClaimsSearchState,
  (state) => state.adjustments,
);

const getAdjustmentsError = createSelector(
  getClaimsSearchState,
  (state) => state.adjustmentsError,
);

const getAdjustmentsLoading = createSelector(
  getClaimsSearchState,
  (state) => state.adjustmentsLoading,
);

const isAccountRestricted = createSelector(
  getClaimsSearchState,
  (state) => state.memberLists && !!state.memberLists[0].hasRestrictedAccount,
);
const isGroupRestricted = createSelector(
  getClaimsSearchState,
  (state) =>
    state.memberLists &&
    state.memberLists.filter((member) => member.hasRestrictedGroup).length > 0,
);

const isReconsiderationHistoryOpened = createSelector(
  getClaimsSearchState,
  (state) => state.isReconsiderationHistoryOpened,
);

const isSupportingInformationTabOpened = createSelector(
  getClaimsSearchState,
  (state) => state.isSupportingInformationTabOpened,
);

const getHistoryData = createSelector(getClaimsSearchState, (state) => {
  if (state.historyDataIndex !== null && state.adjustments?.length) {
    return state.adjustments[state.historyDataIndex];
  }
});

const getProviders = createSelector(
  getClaimsSearchState,
  (state) => state.providers,
);

const getStartAReconsiderationFormData = createSelector(
  getClaimsSearchState,
  (state) => state.startAReconsiderationFormData,
);

const getSupportingInformationHistory = createSelector(
  getClaimsSearchState,
  (state) => state.supportingInformationHistory,
);

const getSupportingInformationHistoryLoading = createSelector(
  getClaimsSearchState,
  (state) => state.supportingInformationHistoryLoading,
);

const getSupportingInformationHistoryError = createSelector(
  getClaimsSearchState,
  (state) => state.supportingInformationHistoryError,
);

const getSupportingInformationUploaded = createSelector(
  getClaimsSearchState,
  (state) => state.supportingInformationUploaded,
);

const getSupportingInformationSubmssionId = createSelector(
  getClaimsSearchState,
  (state) => state.supportingInformationSubmssionId,
);

const getSupportingInformationSubmitLoading = createSelector(
  getClaimsSearchState,
  (state) => state.supportingInformationSubmitLoading,
);

const getSupportingInformationSubmitError = createSelector(
  getClaimsSearchState,
  (state) => state.supportingInformationSubmitError,
);

const getSelectedServiceLines = createSelector(
  getClaimsSearchState,
  (state) => state.selectedServiceLine,
);

export const claimsSearchQuery = {
  getSearchStage,
  getError,
  getMemberSearchCriteria,
  getClaimsSearchCriteria,
  getTabSelection,
  getClaimsSearchResults,
  getClaimDetails,
  getClaimDetailsClaimInfo,
  getClaimDetailsMemberInfo,
  getClaimsDDAR,
  getMemberLists,
  getIsMultiplePatients,
  getUniqueIdentifier,
  getServiceLineInfo,
  getAdjustments,
  getAdjustmentsError,
  getAdjustmentsLoading,
  isAccountRestricted,
  isGroupRestricted,
  getClaimRefNum,
  isReconsiderationHistoryOpened,
  isSupportingInformationTabOpened,
  getHistoryData,
  getProviders,
  getStartAReconsiderationFormData,
  getProviderLoadingState,
  getProviderLoadingError,
  getSupportingInformationHistory,
  getSupportingInformationHistoryLoading,
  getSupportingInformationHistoryError,
  getSupportingInformationUploaded,
  getSupportingInformationSubmssionId,
  getSupportingInformationSubmitLoading,
  getSupportingInformationSubmitError,
  getSelectedServiceLines,
};
